import { useQuery } from '@tanstack/react-query';
import type { MaintenanceStatus } from '@catalyst-psa/shared';

import { publicApi } from '../../features/project-portal/publicApi.js';

const DEFAULT_MESSAGE =
  'Catalyst PSA is undergoing maintenance. You can still view this page, but changes are temporarily disabled — please check back shortly.';

/**
 * Maintenance banner for the unauthenticated portals. Separate from `MaintenanceNotice`
 * because the public tree has no auth context and must not touch MSAL, and because
 * visitors keep read access (the API only rejects their writes) so this never blocks.
 */
export function PublicMaintenanceNotice(): JSX.Element | null {
  const { data } = useQuery({
    queryKey: ['public-maintenance-status'],
    queryFn: () => publicApi.get<MaintenanceStatus>('/maintenance/status'),
    refetchInterval: 30_000,
    refetchIntervalInBackground: true,
    staleTime: 0,
    retry: false,
  });

  if (!data?.enabled) return null;

  return (
    <div
      role="status"
      className="flex flex-wrap items-center justify-center gap-2 bg-amber-500 px-4 py-2 text-center text-sm font-medium text-amber-950"
    >
      <span>{data.message?.trim() || DEFAULT_MESSAGE}</span>
    </div>
  );
}
